import React, {Fragment} from 'react';
import { compose} from "redux";
import { connect as reduxConnect } from "react-redux";
import { connect, replace,FastField } from 'formik';
import { withRouter } from "react-router-dom";
import {Grid,TextField,Divider,Tabs,Tab,Paper,Fade, Collapse} from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import _ from 'lodash'
import styled from 'styled-components';

import {getLoanLosingPRQuotes,getPipelineDealLoanCounts,downloadLoanLosingPRQuotes} from 'store/state/loan/loan';
import { getScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";

import LoanStatuses from 'constants/loanStatuses';

import WinningQuoteTableColumns from 'components/Global/TablePreferenceColumns/LoanTableColumns/WinningQuoteTableColumns';
import LenderPassedLoanTableColumns from 'components/Global/TablePreferenceColumns/LoanTableColumns/LenderPassedLoanTableColumns';
import RejectedLoanTableColumns from 'components/Global/TablePreferenceColumns/LoanTableColumns/RejectedLoanTableColumns';
import ControlledLoanPrefTable from 'components/Global/TablePreferenceColumns/ControlledLoanPrefTable';
import materialStyles from 'components/Pipeline/ActiveDeal/materialStyles';

import {SectionTitle} from './FormSectionComponents';  
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

const QuotesWrapper = styled.div`
  min-height: 350px;
  max-width:1270px;
`
const NoQuotesDiv = styled.div`
  margin-top:8px;
  background:#f2f2f2;
  padding:12px
  color:#999999;  
  font-size: 17px;
`

const VerticalSpacer = styled.div`
height:30px;
display:block;
`

class QuoteHistorySection extends React.Component {  
  state = {
    isExpired: true,
    isExpanded: true,
    tabValue: 0
  };

  tablePaginationHelperWinningQuote = new TablePaginationHelper("2a14c689-44ce-471a-a9d0-022ee6b8a0d5", 10);
  tablePaginationHelperLenderPassed = new TablePaginationHelper("da4761aa-688a-4530-9ee7-2765d152f73f", 10);
  tablePaginationHelperRejected = new TablePaginationHelper("46c2a599-6370-4d7c-aff9-7f9b4d63ad0d", 10);

  componentDidMount(){
    this.props.getScreenPreferences({screenType:"winning_quote_loan_table"});
    this.props.getScreenPreferences({screenType:"lender_passed_loan_table"});
    this.props.getScreenPreferences({screenType: 'rejected_loan_table'});
  }

  componentDidUpdate(prevProps,prevState){
    const {winningQuotePrefs,formik} = this.props;
    const loanId = formik.values.details.id;
    if(winningQuotePrefs && loanId && this.state.isExpired){      
      this.setState({isExpired: false});
      this.getPaginatedWinningQuote(this.tablePaginationHelperWinningQuote.page, this.tablePaginationHelperWinningQuote.rowsPerPage);      
    }  
  }
  
  getPaginatedWinningQuote = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    let desiredColumns = this.getWinningQuotePreferenceColumns();
    if(desiredColumns)
    this.props.getLoanLosingPRQuotes({
      subKey: 'winning_quote_loan_table',
      loanStatusId: LoanStatuses.WINNING_QUOTE,
      loanId: loanId,
      columns: desiredColumns,
      page: this.tablePaginationHelperWinningQuote.page,
      pageSize: this.tablePaginationHelperWinningQuote.rowsPerPage
    })
  }  

  getPaginatedLenderPassed = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    let desiredColumns = this.getLenderPassedPreferenceColumns();
    if(desiredColumns)
    this.props.getLoanLosingPRQuotes({
      subKey: 'lender_passed_loan_table',
      loanStatusId: LoanStatuses.PASSED_QUOTE,
      loanId: loanId,
      columns: desiredColumns,
      page: this.tablePaginationHelperLenderPassed.page,
      pageSize: this.tablePaginationHelperLenderPassed.rowsPerPage
    })
  }

  getWinningQuotePreferenceColumns = () => {
    const {winningQuotePrefs} = this.props;
    if(winningQuotePrefs){
      const prefElementIds = winningQuotePrefs.map(x => x.screenElementId);        
      return WinningQuoteTableColumns
        .filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id )) 
        .map(x => x.dataField);
  }}

  getLenderPassedPreferenceColumns = () => {
    const {lenderPassedPrefs} = this.props;
    if(lenderPassedPrefs){
      const prefElementIds = lenderPassedPrefs.map(x => x.screenElementId);        
      return LenderPassedLoanTableColumns
        .filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id )) 
        .map(x => x.dataField);
  }}

  getPaginatedRejected = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    let desiredColumns = this.getRejectedPreferenceColumns();
    if(desiredColumns)
    this.props.getLoanLosingPRQuotes({
      subKey: 'rejected_loan_table',
      loanStatusId: LoanStatuses.REJECTED_QUOTE,
      loanId: loanId,
      columns: desiredColumns,
      page: this.tablePaginationHelperRejected.page,
      pageSize: this.tablePaginationHelperRejected.rowsPerPage
    })
  }

  getRejectedPreferenceColumns = () => {
    const {rejectedPrefs} = this.props;
    if(rejectedPrefs){
      const prefElementIds = rejectedPrefs.map(x => x.screenElementId);        
      return RejectedLoanTableColumns
        .filter(x => x.id && x.dataField && _.includes(prefElementIds, x.id )) 
        .map(x => x.dataField);
    }
  }

  onExpired = (expiration) => {
    this.setState({
      isExpired:expiration,
    })
  }

  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
    if(value === 0)
      this.getPaginatedWinningQuote();
    if(value === 1)
    this.getPaginatedRejected();
    if(value === 2)
    this.getPaginatedLenderPassed();
  };

  winningQuoteUpdateTableState = (payload) => {
    this.setState({
      winningQuoteTableState: {
        ...payload
      }
    })
    this.getPaginatedWinningQuote();
  };

  lenderPassedUpdateTableState = (payload) => {
    this.setState({
      lenderPassedTableState: {
        ...payload
      }
    })
    this.getPaginatedLenderPassed();
  };

  rejectedUpdateTableState = (payload) => {
    this.setState({
      rejectedTableState: {
        ...payload
      }
    });    
    this.getPaginatedRejected();
  };  

  downloadWinningQuotes = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    const payload = {
      loanStatusId: LoanStatuses.WINNING_QUOTE,
      loanId: loanId,
      columns: [
        "amount",
        "ltvAsIs",
        "loanTermMonths",
        "amortizationTerm",
        "loanSpread",        
        "indexId",
        "loanTypeId"
      ],
      page: 1,
      pageSize: 100
    };
    this.props.downloadWinningQuotes(payload);
  }
  
  downloadPassedLoans = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    const payload = {
      loanStatusId: LoanStatuses.PASSED_QUOTE,
      loanId: loanId,
      columns: [
        "lenderCompanyId",   
        "passReasonId",
        "passComment"
      ],
      page: 1,
      pageSize: 100
    };
    this.props.downloadLoanLosingPRQuotes(payload);
  }
  
  downloadRejectedLoans = () => {
    const {formik} = this.props;
    const loanId = formik.values.details.id;
    const payload = {
      loanStatusId: LoanStatuses.REJECTED_QUOTE,
      loanId: loanId,
      columns: [
        "amount",
        "ltvAsIs",
        "loanTermMonths",
        "amortizationTerm",
        "loanSpread",        
        "indexId",
        "loanTypeId"
      ],
      page: 1,
      pageSize: 100
    };
    this.props.downloadLoanLosingPRQuotes(payload);
  }

  render(){    
    const {formik} = this.props;
    const {isExpired, tabValue} = this.state;
    const {
      classes,
      
      winningQuoteLoanData, 
      winningQuotePrefs,
      winningQuoteCount,

      lenderPassedLoanData, 
      lenderPassedPrefs,
      lenderPassedCount,
      
      rejectedLoanData,
      rejectedPrefs,      
      rejectedCount,      

      match: {
        params: { dealId }
      }
    } = this.props;

    return (
      <Fragment>
        <div id="quote_history_section">
          <VerticalSpacer/>
          <SectionTitle>Quote History</SectionTitle>        
          <Grid container direction="column">
              <Tabs
                value={tabValue}
                onChange={this.handleTabChange}
                classes={{ indicator: classes.tabsIndicator }}>
                  <Tab
                    disableRipple
                    label="Winning Quote"
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected
                    }}
                  />
                    <Tab
                      disableRipple
                      label="Rejected"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected
                      }}
                    />
                  <Tab
                    disableRipple
                    label="Lender Passed"
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected
                    }}
                  />
              </Tabs>
              {
                tabValue === 0 &&
                <QuotesWrapper>            
                {  winningQuoteCount > 0 &&
                  <Fade in={winningQuoteLoanData.data !== null}>
                    <Paper elevation={4}>
                    <ControlledLoanPrefTable                   
                        updateTableState={this.winningQuoteUpdateTableState}
                        setExpired={this.onExpired}                        
                        screenType='winning_quote_loan_table' 
                        tableScreenElements={WinningQuoteTableColumns}
                        screenPreferences={winningQuotePrefs}                              
                        dealId={dealId}
                        tableData={winningQuoteLoanData}
                        downloadLoans={this.downloadWinningQuotes}
                      />
                    </Paper>
                  </Fade>
                }
                {winningQuoteCount === 0 && 
                <Fade in={winningQuoteCount === 0}>
                  <Paper elevation={4}>
                    
                      <NoQuotesDiv>There are no quotes for this deal</NoQuotesDiv>
                    
                  </Paper>
                </Fade> }
                </QuotesWrapper> 
              }
              {
                tabValue === 1 &&
                  <QuotesWrapper>            
                  {  rejectedCount > 0 &&
                    <Fade in={rejectedLoanData.data !== null}>
                      <Paper elevation={4}>
                      <ControlledLoanPrefTable                  
                        updateTableState={this.rejectedUpdateTableState}
                        setExpired={this.onExpired}
                        screenType='rejected_loan_table' 
                        tableScreenElements={RejectedLoanTableColumns}
                        screenPreferences={rejectedPrefs}                              
                        dealId={dealId}
                        tableData={rejectedLoanData}
                        downloadLoans={this.downloadRejectedLoans}
                      />
                      </Paper>
                    </Fade>
                  }
                  {  rejectedCount === 0 &&
                  <Fade in={rejectedCount === 0}>
                    <Paper elevation={4}>
                        <NoQuotesDiv>There are no quotes for this deal</NoQuotesDiv>                      
                    </Paper>
                  </Fade>
                  }
                </QuotesWrapper>  
              }
              {
                tabValue === 2 &&
                <QuotesWrapper>            
                {  lenderPassedCount > 0 &&
                  <Fade in={lenderPassedLoanData.data !== null}>
                    <Paper elevation={4}>
                    <ControlledLoanPrefTable                   
                        updateTableState={this.lenderPassedUpdateTableState}
                        setExpired={this.onExpired}
                        shouldHideConfig={true}
                        screenType='lender_passed_loan_table' 
                        tableScreenElements={LenderPassedLoanTableColumns}
                        screenPreferences={lenderPassedPrefs}                              
                        dealId={dealId}
                        tableData={lenderPassedLoanData}
                        downloadLoans={this.downloadPassedLoans}
                      />
                    </Paper>
                  </Fade>
                }
                {lenderPassedCount === 0 && 
                <Fade in={lenderPassedCount === 0}>
                  <Paper elevation={4}>
                    
                      <NoQuotesDiv>There are no quotes for this deal</NoQuotesDiv>
                    
                  </Paper>
                </Fade> }
                </QuotesWrapper> 
              }

          </Grid>
        </div>
      </Fragment>
  )};
}

const mapStateToProps = ({ authentication,loan,screenPreferences}) => ({
  authentication,  
  winningQuotePrefs: screenPreferences.screen_pref.winning_quote_loan_table,
  lenderPassedPrefs: screenPreferences.screen_pref.lender_passed_loan_table,
  rejectedPrefs: screenPreferences.screen_pref.rejected_loan_table,

  winningQuoteLoanData: loan.loanLosingPRQuotes.winning_quote_loan_table || {},
  lenderPassedLoanData: loan.loanLosingPRQuotes.lender_passed_loan_table || {},
  rejectedLoanData: loan.loanLosingPRQuotes.rejected_loan_table || {},  
  
  winningQuoteCount: loan.loanLosingPRQuotes.winning_quote_loan_table? loan.loanLosingPRQuotes.winning_quote_loan_table.data.count : 0,
  lenderPassedCount: loan.loanLosingPRQuotes.lender_passed_loan_table? loan.loanLosingPRQuotes.lender_passed_loan_table.data.count : 0,
  rejectedCount: loan.loanLosingPRQuotes.rejected_loan_table? loan.loanLosingPRQuotes.rejected_loan_table.data.count : 0, 
});

export default compose(  
  connect,
  reduxConnect(
    mapStateToProps,
        { getLoanLosingPRQuotes,      
      getPipelineDealLoanCounts,
      getScreenPreferences,
      downloadLoanLosingPRQuotes,} 
  ),
  withStyles(materialStyles),
)(withRouter(QuoteHistorySection));